import Box from "@mui/material/Box";
import OrderCustomerContactsCard from "./OrderCustomerContactsCard";
import OrderCustomerPersonalizationCard from "./OrderCustomerPersonalizationCard";

const OrderPartyRequisitesTab = ({handleModalAlert}) => (
    <Box sx={{display: "flex", flexDirection: "column", gap: "24px", width: "100%"}}>
        <OrderCustomerContactsCard/>
        <OrderCustomerPersonalizationCard handleModalAlert={handleModalAlert}/>
    </Box>
);

export default OrderPartyRequisitesTab;
